import React, { useState, useEffect } from "react";
import { translations, LanguageCode } from "../utils/translations";

interface UserProfileProps {
  lang?: LanguageCode;
}

const UserProfile: React.FC<UserProfileProps> = ({ lang = "en" }) => {
  const t = translations[lang].userProfile;
  const [form, setForm] = useState({
    phone: "",
    address: "",
    companyName: "",
    companyAddress: "",
  });

  useEffect(() => {
    const stored = localStorage.getItem("user_profile");
    if (stored) {
      setForm(JSON.parse(stored));
    }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (!form.phone || !form.companyName) {
      alert(t.requiredAlert);
      return;
    }

    localStorage.setItem("user_profile", JSON.stringify(form));
    alert(t.savedAlert);
  };

  return (
    <div>
      <h2>{t.title}</h2>

      <h3>{t.personalInfo}</h3>
      <input
        name="phone"
        placeholder={t.phone}
        value={form.phone}
        onChange={handleChange}
      />
      <br />
      <input
        name="address"
        placeholder={t.address}
        value={form.address}
        onChange={handleChange}
      />

      <h3 style={{ marginTop: "20px" }}>{t.companyInfo}</h3>
      <input
        name="companyName"
        placeholder={t.companyName}
        value={form.companyName}
        onChange={handleChange}
      />
      <br />
      <input
        name="companyAddress"
        placeholder={t.companyAddress}
        value={form.companyAddress}
        onChange={handleChange}
      />

      <br />
      <button
        style={{ marginTop: "20px", padding: "8px 16px" }}
        onClick={handleSubmit}
      >
        {t.save}
      </button>
    </div>
  );
};

export default UserProfile;
